<template>
  <hic-list-page title="治疗标准编码" :entities="entities" :condition="condition" @load="page"
    :loading="meta.loading" keyword-placeholder="请输入名称或编码">
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small">
        <i class="el-icon-plus"></i>
        新建
      </el-button>
    </template>

    <el-table-column label="操作" width="150" align="center">
      <template #default="scope">
        <el-button type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" />

        <hic-regret-button type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)"
          :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>

        <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" min-width="300">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" width="100" align="left">
      <template slot-scope="{ row }">
        {{ row.code }}
      </template>
    </el-table-column>

    <el-table-column label="规格" prop="standard" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.standard }}
      </template>
    </el-table-column>

    <el-table-column label="单位" prop="unit" width="150" align="center" :filter-multiple="false" :filters="dict.Unit"
      column-key="unit">
      <template slot-scope="{ row }">
        {{ row.unit | dictText('Unit') }}
      </template>
    </el-table-column>

    <el-table-column label="单价" prop="unit" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.price }}
      </template>
    </el-table-column>

    <el-table-column label="助记符" prop="shortCode" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.shortCode }}
      </template>
    </el-table-column>

    <el-table-column label="医保编码" prop="insuranceCode" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.insuranceCode }}
      </template>
    </el-table-column>

    <el-table-column label="检治编码类型" prop="examineStandardType" width="150" align="center" :filter-multiple="false"
      column-key="examineStandardType">
      <template slot-scope="{ row }">
        {{ row.examineStandardType }}
      </template>
    </el-table-column>

    <el-table-column label="附加类别" prop="additionType" width="150" align="center" :filter-multiple="false"
      :filters="dict.AdditionType" column-key="additionType">
      <template slot-scope="{ row }">
        {{ row.additionType | dictText('AdditionType') }}
      </template>
    </el-table-column>

    <el-table-column label="费用类别" prop="feeType" width="150" align="center" :filter-multiple="false"
      :filters="dict.FeeType" column-key="feeType">
      <template slot-scope="{ row }">
        {{ row.feeType | dictText('FeeType') }}
      </template>
    </el-table-column>

    <el-table-column label="结算类别" prop="settleType" width="150" align="center" :filter-multiple="false"
      column-key="settleType" :filters="dict.SettleType">
      <template slot-scope="{ row }">
        {{ row.settleType | dictText('SettleType') }}
      </template>
    </el-table-column>

    <el-table-column label="病案类别" prop="recordType" width="150" align="center" :filter-multiple="false"
      column-key="recordType" :filters="dict.RecordType">
      <template slot-scope="{ row }">
        {{ row.recordType | dictText('RecordType') }}
      </template>
    </el-table-column>

    <el-table-column label="统计类别" prop="statisticType" width="150" align="center" :filter-multiple="false"
      column-key="statisticType" :filters="dict.StatisticType">
      <template slot-scope="{ row }">
        {{ row.statisticType | dictText('StatisticType') }}
      </template>
    </el-table-column>

    <!-- <el-table-column
          label="执行科室编码"
          prop="deptCodes"
          width="250"
          align="center"
          :filter-multiple="false"
           :filters="dict.deptCode" 
        >
          <template slot-scope="{ row }">
            {{ row.deptCodes | dictText("deptCode") }}
          </template>
        </el-table-column> -->

    <el-table-column label="是否打印" prop="ifPrint" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        <el-tag :type="row.ifPrint ? 'success' : 'danger'">{{
            row.ifPrint ? '是' : '否'
        }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="停用标志" prop="disabled" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        <el-tag :type="row.disabled ? 'success' : 'danger'">{{
            row.disabled ? '是' : '否'
        }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="门诊使用" prop="forOp" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        <el-tag :type="row.forOp ? 'success' : 'danger'">{{
            row.forOp ? '是' : '否'
        }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="住院使用" prop="forIp" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        <el-tag :type="row.forIp ? 'success' : 'danger'">{{
            row.forIp ? '是' : '否'
        }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="医技使用" prop="forMl" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        <el-tag :type="row.forMl ? 'success' : 'danger'">{{
            row.forMl ? '是' : '否'
        }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="设备类型" prop="equipmentType" width="150" align="center" :filter-multiple="false"
      column-key="equipmentType" :filters="dict.EquipmentType">
      <template slot-scope="{ row }">
        {{ row.equipmentType | dictText('EquipmentType') }}
      </template>
    </el-table-column>

    <el-table-column label="备注" prop="memo" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.memo }}
      </template>
    </el-table-column>

    <el-table-column label="说明" prop="desc" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.desc }}
      </template>
    </el-table-column>

    <el-table-column label="除外" prop="exception" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.exception }}
      </template>
    </el-table-column>

    <el-table-column label="国标编码" prop="gbCode" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.gbCode }}
      </template>
    </el-table-column>

    <staff-edit v-if="showEditor" :visible.sync="showEditor" :staff="entity" @ok="ok" />
  </hic-list-page>
</template>

<script>
import api from './api.js';
import { mapGetters } from 'sw-hic';
export default {
  components: {
    'staff-edit': () => import('./edit'),
  },
  data() {
    return {
      showEditor: false,
      showRoles: false,
      entities: {},
      entity: {},
      condition: {
        keyword: null,
        deptCode: null,
        pageIndexOnView: 1,
        pageSize: 20,
      },
      meta: {
        loading: false,
      },
      editingIndex: -1,
    };
  },
  computed: {
    ...mapGetters(['dict', 'permission']),
  },
  created: function () {
    this.$store.dispatch('loadDicts', [
      'Dept',
      'Gender',
      'StaffType',
      'DoctorPosition',
    ]);
  },
  methods: {
    rowClick(row) {
      if (this.isSwitch) {
        this.$set(row, 'isProduce', !row.isProduce);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.isSwitch) {
        if (row.isProduce) {
          return 'active-row';
        }
        return 'shover-row';
      }
    },
    // produce() {
    //   // this.$message.info('开发设计中');
    //   let items = this.entities.items.filter((f) => f.isProduce);
    //   items.forEach(async (item, index) => {
    //     try {
    //       await api.saveItem({
    //         name: item.name,
    //         srcCode: item.code,
    //         srcType: "标准编码",
    //       });
    //       if (index == items.length - 1) {
    //         this.$message.success("生成成功!");
    //         this.isSwitch = false;
    //       }
    //     } catch (error) {
    //       this.$message.error(error);
    //     }
    //   });
    // },
    tools() {
      this.isSwitch = true;
    },
    page: function () {
      let _this = this;
      this.meta.loading = true;
      api
        .Standard.query(this.condition)
        .then((res) => {
          _this.entities = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          _this.meta.loading = false;
        });
    },
    create() {
      this.editingIndex = 0;
      this.entity = {
        id: null,
        joinDate: new Date(),
        price: '',
      };
      this.showEditor = true;
    },
    edit(row, index) {
      this.entity = JSON.parse(JSON.stringify(row));
      this.showEditor = true;
    },
    ok(newEntity) {
      this.page();
    },
    del: function (row, index) {
      let _this = this;
      api.Standard.del(row.id).then((res) => {
        _this.entities.items.splice(index, 1, {});
        _this.$message.success('删除成功！');
      });
    },
    bingRole(row) {
      this.entity = row;
      this.showRoles = true;
    },
  },
};
</script>

<style scoped>
.el-table /deep/ .active-row {
  background: #f5f7fa;
  cursor: pointer;
  color: #66b1ff;
}

.el-table /deep/ .shover-row {
  cursor: pointer;
}
</style>
